"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bem_cn_1 = require("bem-cn");

var block = bem_cn_1.setup();

function bemClassNameLite(blockName) {
  var b = block(blockName);

  function element() {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    var elementName = args.shift();
    var modifiers = args[0],
        mixin = args[1];
    var result;

    if (typeof elementName !== 'string' || typeof modifiers === 'string') {
      mixin = modifiers;
      modifiers = null;
    }

    result = b(elementName, modifiers);

    if (mixin) {
      result = result.mix(mixin);
    }

    return result.toString();
  }

  element.builder = function () {
    return b;
  };

  return element;
}

bemClassNameLite.setup = function (config) {
  block = bem_cn_1.setup(config);
};

bemClassNameLite.reset = function () {
  block = bem_cn_1.setup();
};

exports["default"] = bemClassNameLite;